import { Route, Routes } from "react-router-dom";

import { NotFound } from "../../misc";
import ClassBasedAugmentation from "../components/ClassBasedAugmentation";
import AnnotationROI from "../components/AnnotationROI";

/**
 * ClassBasedAugmentationRoutes
 * Defines the routing for the Class-Based Augmentation module.
 * - Renders the ClassBasedAugmentation component at the root path ("/") and for "/:marked".
 * - Renders the AnnotationROI component at "/roi" and "/roi/:image_id/:part_id".
 * - Renders the NotFound component for all other undefined paths.
 * Note: The 'component' attribute will not work in React Router v6; use 'element' instead.
 */
export const ClassBasedAugmentationRoutes = () => {
    return (
      <Routes>
        {/* Route for the main class-based augmentation page */}
        <Route path="/" element={<ClassBasedAugmentation />} />
        {/* Route for class-based augmentation with a marked parameter */}
        <Route path="/:marked" element={<ClassBasedAugmentation />} />
        {/* Route for annotation ROI page */}
        <Route path="/roi" element={<AnnotationROI />} />
        {/* Route for annotation ROI with image and part IDs */}
        <Route path="/roi/:image_id/:part_id" element={<AnnotationROI />} />
        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  };